import React from 'react';
import { View } from 'react-native';
import Svg, { Path, Rect } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import { IS_WEB } from '@/utils/platform';

export const ExerciseMaterial = ({
  color,
  size = 24,
  style,
  ...props
}: IconProps) => {
  if (IS_WEB) {
    return (
      <View {...props}>
        <svg
          width={size}
          height={size}
          viewBox="0 0 44 44"
          fill="none"
          style={style as React.CSSProperties}
        >
          <rect
            x="13"
            y="16"
            width="18"
            height="15"
            rx="1"
            stroke={color}
            strokeWidth="2"
          />
          <path
            d="M30.9997 17.5V16L28.5 12.5H15.5L12.9997 16L12.999 17.5"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 17V24L22 22.5L25 24V16.5"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </View>
    );
  }

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 44 44"
      fill="none"
      style={style}
      {...props}
    >
      <Rect
        x="13"
        y="16"
        width="18"
        height="15"
        rx="1"
        stroke={color}
        strokeWidth="2"
      />
      <Path
        d="M30.9997 17.5V16L28.5 12.5H15.5L12.9997 16L12.999 17.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19 17V24L22 22.5L25 24V16.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
